import React from "react";
import { Box } from "@material-ui/core";
import { NavLink } from "react-router-dom";

const FooterLogo = ({ color, ...props }) => {

  return (
    <Box className="pointer" {...props}>
      <NavLink to="/">{/* <CmtImage src={logoUrl} alt="logo" /> */}</NavLink>
    </Box>
  );
};

export default FooterLogo;
